<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="clientes"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Clientes</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" class="mt-n6 mx-auto">
                        <v-text-field
                          v-model="nombre"
                          label="Nombre"
                          outlined
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                        <v-text-field
                          v-model="clienteigas"
                          label="ID Sistema"
                          outlined
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                        <v-select
                          v-model="empresaid"
                          :items="empresaselect"
                          label="Nombre de la Empresa"
                          outlined
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                        <v-text-field
                          v-model="clientetelefono"
                          label="Telefono"
                          outlined
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="mt-n6 mx-auto">
                        <v-text-field
                          v-model="clientemail"
                          label="Correo Electronico"
                          outlined
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                        <v-text-field
                          v-model="clientecreditolimite"
                          label="Limite de Credito"
                          outlined
                          type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-select v-model="creditofacturaid" :items="creditofacturaselect"
                          label="Carga o Gasto" outlined></v-select>
                      </v-col>
                      

                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <v-row
                          class="red--text"
                          v-for="v in validamensaje"
                          :key="v"
                          v-text="v"
                        ></v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="guardar"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.condicion="{ item }">
          <v-card-text v-if="item.condicion" class="blue--text"
            >Activo</v-card-text
          >
          <v-card-text v-if="!item.condicion" class="red--text"
            >Inactivo</v-card-text
          >
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // Variable categoria
      clientes: [],
      dialog: false,
      headers: [
        { text: "Accciones", value: "action", sortable: false },
        { text: "Cliente ID", value: "clienteigas" },
        { text: "Nombre", value: "clientenombre" },
        { text: "Empresa", value: "empresanombre" },
      ],
      search: "",
      editedIndex: -1,
      id: "",
      nombre: "",
      tipo_documento: "",
      documentos: ["DNI", "RUC", "PASAPORTE", "CEDULA"],
      num_documento: "",
      direccion: "",
      telefono: "",
      email: "",
      valida: 0,
      validamensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      clienteigas: "",
      clienteid: "",
      empresaid: "",
      empresaselect: [],
      clientetelefono: "",
      clientemail: "",
      clientecreditolimite: "",
      creditofacturaid:"",
      creditofacturaselect: [
        { text: "SI FACTURA", value: 1 },
        { text: "NO FACTURA", value: 2 }
      ],
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Cliente" : "Actualizando Cliente";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.selectempresa();
  },

  //
  methods: {
    // metodo listar
    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/clientes/listar", configuracion)
        .then(function(response) {
          me.clientes = response.data.cliente;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectempresa() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/empresas/listar", configuracion)
        .then(function(response) {
          listaArray = response.data.empresa;
          listaArray.map(function(x) {
            me.empresaselect.push({
              text: x.empresanombre,
              value: x.empresaid,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Actualiza la categotia
    editItem(item) {
      this.id = item.idpersona;
      this.nombre = item.clientenombre;
      this.tipo_documento = item.tipo_documento;
      this.num_documento = item.num_documento;
      this.direccion = item.direccion;
      this.telefono = item.telefono;
      this.email = item.email;
      this.editedIndex = 1;
      this.dialog = true;
      this.clienteid = item.clienteid;
      this.clienteigas = item.clienteigas;
      this.clientetelefono = item.clientetelefono;
      this.clientemail = item.clientemail;
      this.clientecreditolimite = item.clientecreditolimite;
      this.empresaid = item.empresaid;
      this.creditofacturaid=item.clientefacturasino
  
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.nombre = "";
      this.clienteigas = "";
      this.clienteid = "";
      this.editedIndex = -1;
      this.clientetelefono = "";
      this.clientemail = "";
      this.clientecreditolimite = "";
      this.creditofacturaid="";
    },

    guardar() {
      if (this.validar()) {
        return;
      }
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //Editar
        let me = this;
        axios
          .post(
            "api/clientes/actualizar",
            {
              clienteid: me.clienteid,
              clientenombre: me.nombre,
              clienteigas: me.clienteigas,
              empresaid: me.empresaid,
              usuarioid: me.$store.state.usuario.usuarioid,
              clientetelefono: me.clientetelefono,
              clientemail: me.clientemail,
              clientecreditolimite: me.clientecreditolimite,
              clientefacturasino:me.creditofacturaid
            },
            configuracion
          )
          .then(function(response) {
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        //Guardar
        let me = this;
        axios
          .post(
            "api/clientes/crear",
            {
              clientenombre: me.nombre,
              clienteigas: me.clienteigas,
              empresaid: me.empresaid,
              usuarioid: me.$store.state.usuario.usuarioid,
              clientetelefono: me.clientetelefono,
              clientemail: me.clientemail,
              clientecreditolimite: me.clientecreditolimite,
              clientefacturasino:me.creditofacturaid
            },
            configuracion
          )
          .then(function(response) {
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.nombre) {
        this.validamensaje.push("El Nombre del Cliente Esta Vacio");
      }
      if (!this.clienteigas) {
        this.validamensaje.push("El Numero de Cliente Esta Vacio");
      }
      if (!this.empresaid) {
        this.validamensaje.push("La Empresa Esta Vacia");
      }
      if (this.validamensaje.length) {
        this.valida = 1;
      }

      return this.valida;
    },
  },
};
</script>
